import React from 'react'
import { Row, Container } from 'react-bootstrap';
import './casestudybody48.css';

import clientimg from '../images/case-study-client48.webp'
import outcome from '../images/outcome48.webp'

import sm1 from '../images/cs48so1.webp'
import sm2 from '../images/cs48so2.webp'
import sm3 from '../images/cs48so3.webp'
import sm4 from '../images/cs48so4.webp'


const Casestudybody48 = () => {

    return (
        <>
        <section className='casestudybody48-section'  >
          <Container>

            <Row className='w-100 py-md-5 py-4 clintrow'>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <h2>About</h2>
                      {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                      <div className="h1">The Client</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>The client is a developer focused on transformational real estate. It develops sustainable, high-impact projects by partnering with specialist operators through flexible, performance-driven commercial models</p>
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={clientimg} alt="" />
                </div>
            </Row>
       
            <Row className='mt-md-5'>
              <div className='col-md-12'>
                <div className='content-box'>
                  <h2>Situation</h2>
                  {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                  <div className="h1">Overview</div>
                  <p className='anima '><span className='only-anima-underline' > **** </span></p>
                  <p>The client required a structured due diligence to assess a prospective JV with a green building materials manufacturer, developing a data-backed view on partnership viability and key risk considerations</p>
                </div>               
              </div>
            </Row>
          </Container>
        </section>
    
        <section className='casestudybody48-section bg-gredient-dark'>
          <Container>
            <Row>
              <div className='col-md-12'>
                  <div className='content-box'>
                    <h2>Approach &</h2>
                    {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                    <div className="h1">Methodology</div>
                    <p className='anima '><span className='only-anima-underline' > **** </span></p>
                    {/* <p>The next step was to put together and implement a step-by-step process for conducting the valuation:</p> */}
                    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Deal Objectives & Partner Capability Assessment: </h4>
                          <p>Conducted a detailed review of the <span style={{color:"#03A393",fontWeight:700}}> partners strategic objectives, current project portfolio, operational capabilities</span> and <span style={{color:"#03A393",fontWeight:700}}> technology infrastructure</span> to evaluate the <span style={{color:"#03A393",fontWeight:700}}> feasibility, scalability</span> and <span style={{color:"#03A393",fontWeight:700}}> reliability</span> of the proposed joint venture</p>
                        </div>
                      </div>
    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Financial Due Diligence & Data Validation:</h4>
                          <p>Assessed the JV's proposed operating and financial model and issued a comprehensive information request list to <span style={{color:"#03A393",fontWeight:700}}> validate assumptions, ensure completeness</span> of <span style={{color:"#03A393",fontWeight:700}}> financial inputs</span> and <span style={{color:"#03A393",fontWeight:700}}> identify potential data gaps</span> or inconsistencies</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Commercial & Operational Scenario Modelling:</h4>
                          <p>Developed and analysed <span style={{color:"#03A393",fontWeight:700}}> multiple commercial</span> and <span style={{color:"#03A393",fontWeight:700}}> operational scenarios</span> by varying <span style={{color:"#03A393",fontWeight:700}}> key assumptions, including cost structures, capacity utilization, timelines</span> and <span style={{color:"#03A393",fontWeight:700}}> execution efficiency,</span> to assess potential outcomes and sensitivities</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Risk Assessment & Strategic Alignment:</h4>
                          <p>Identified and evaluated <span style={{color:"#03A393",fontWeight:700}}> key financial, operational</span> and <span style={{color:"#03A393",fontWeight:700}}> execution risks, including potential constraints, dependencies</span> and <span style={{color:"#03A393",fontWeight:700}}> governance considerations.</span> Assessed overall alignment with the client’s <span style={{color:"#03A393",fontWeight:700}}> construction objectives, delivery timelines</span> and <span style={{color:"#03A393",fontWeight:700}}> risk appetite</span></p>
                        </div>
                      </div>

                      <div className='list-text last-child my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Strategic Recommendation & Mitigation Framework: </h4>
                          <p>Recommended proceeding with the JV subject to strengthened <span style={{color:"#03A393",fontWeight:700}}> contractual safeguards, clearly defined cost-sharing arrangements, measurable performance milestones</span> and a phased rollout approach to mitigate execution and downside risks</p>
                        </div>
                      </div>     

                                        
                      <h3 className='mt-5'>Sample Output</h3>
                      <div className='sample-output mt-3'>
                        <img src={sm1} alt=''/>
                        <img src={sm2} alt=''/>
                        <img src={sm3} alt=''/>
                        <img src={sm4} alt=''/>
                      </div>
                  </div>
                  
                </div>
            </Row>
          </Container>
        </section>

    
        <section className='casestudybody48-section outcome'  >
          <Container>
            <Row className='w-100 pb-5 clintrow '>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <div className="h1">Outcome</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>Conducted thorough due diligence and delivered a comprehensive deal analysis, enabling the client to assess the commercial and financial viability of the proposed partnership, clarify projected outcomes and support informed strategic planning</p>  
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={outcome} alt="" />
                </div>
            </Row>
       
          </Container>
        </section>
    
        </>  
      )
    }

export default Casestudybody48
